/* Payal Jewellers — product page extras: pincode checker + size-chart dialog.
   Guarded so multiple blocks/instances don't double-bind. */

// --- Pincode / delivery checker (custom element) ---
if (!customElements.get('pincode-checker')) {
  customElements.define(
    'pincode-checker',
    class PincodeChecker extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.product__pincode-input');
        this.button = this.querySelector('.product__pincode-btn');
        this.result = this.querySelector('.product__pincode-result');
        this.eta = this.dataset.eta || '';
        this.list = (this.dataset.pincodes || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);

        if (!this.input || !this.button) return;
        this.button.addEventListener('click', () => this.check());
        this.input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.check();
          }
        });
        this.input.addEventListener('input', () => {
          this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
        });
      }

      check() {
        const pin = (this.input.value || '').trim();
        this.result.hidden = false;
        if (!/^\d{6}$/.test(pin)) {
          this.setResult('Please enter a valid 6-digit pincode.', 'error');
          return;
        }
        const serviceable = this.list.length === 0 || this.list.includes(pin);
        if (serviceable) {
          this.setResult(
            'Delivery available to ' + pin + (this.eta ? ' — ' + this.eta + '.' : '.'),
            'ok'
          );
        } else {
          this.setResult("Sorry, we don't deliver to " + pin + ' yet.', 'error');
        }
      }

      setResult(message, state) {
        this.result.textContent = message;
        this.result.dataset.state = state;
      }
    }
  );
}

// --- Size-chart dialog (event delegation, bound once) ---
if (!window.__pjSizeChartBound) {
  window.__pjSizeChartBound = true;
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-chart-open]');
    if (opener) {
      const dialog = document.getElementById('SizeChart-' + opener.getAttribute('data-size-chart-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else if (dialog) {
        dialog.setAttribute('open', '');
      }
      return;
    }
    const closer = event.target.closest('[data-size-chart-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }
    // Click on backdrop closes the dialog.
    if (event.target.matches('dialog.size-chart-dialog')) {
      event.target.close();
    }
  });
}
